import { IQuery, IQueryMediator } from 'core-ts-types';
import { TermProgramInfoModel } from '../../../views/term_courses/models/term_program_info_model';
import * as _4 from 'lodash4';
import { TimeSliceServant } from '../servants/time_slice_servant';
import { ITimeSliceQueryResult } from '../../../interfaces/scheduler_interfaces';
import { SelectedTimeSliceModel } from '../models/selected_time_slice_model';

export class TimeSliceQuery implements IQuery {
  private _result: {
    slices: ITimeSliceQueryResult[];
  };

  constructor(
    private QueryMediator: IQueryMediator,
    private ngTermProgramInfoModel: TermProgramInfoModel,
    private ngTimeSliceServant: TimeSliceServant,
    private ngSelectedTimeSliceModel: SelectedTimeSliceModel
  ) {
    this._result = {
      slices: []
    };
    QueryMediator.registerQuery(this, ngTermProgramInfoModel, ngSelectedTimeSliceModel);
  }

  run() {
    const termInfo = this.ngTermProgramInfoModel.read();

    const timeSliceStartDate = moment(_4.get(termInfo, 'term.term_start_dt'));
    const timeSliceEndDate = moment(_4.get(termInfo, 'term.term_end_dt'));

    const builtTimeSlices = this.ngTimeSliceServant.buildTimeSlices(timeSliceStartDate, timeSliceEndDate);

    this._result = {
      slices: builtTimeSlices
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngTimeSliceQuery', TimeSliceQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/time_slice_tiles/queries/time_slice_query.ts